module.exports = __webpack_public_path__ + "img/ics_f_announce_green.e7cc747a.svg";